import request from '@/utils/request'

// 获取余额
export function getBalance() {
  return request({
    url: '/user/balance',
    method: 'get',
  })
}

//获取绑卡验证码
export function getBindCardCode(data: {
  bankAccountNo: string,
  bankMobile: string
}) {
  return request({
    url: '/wallet/add_card',
    method: 'post',
    data
  })
}

//绑定银行卡
export function bindCard(data: {
  authSn: string,
  requestNo: string,
  smsCode: string
}) {
  return request({
    url: '/wallet/add_card_confirm',
    method: 'post',
    data
  })
}

//解绑银行卡
export function unbindCard(data: {
  linkId: string
}) {
  return request({
    url: '/wallet/unbind_card',
    method: 'post',
    data
  })
}

//获取支持的银行列表
export function getBankList() {
  return request({
    url: '/wallet/bank_list',
    method: 'get',
  })
}

//获取银行卡列表
export function getCardList() {
  return request({
    url: '/wallet/card_list',
    method: 'get',
  })
}

//充值
export function recharge(data: {
  amount: string,
  linkId: string,
  remark: string,
  type: number  //0银行卡 1支付宝 2微信 3钱包 4云闪付
}) {
  return request({
    url: '/order/balance_recharge',
    method: 'post',
    data
  })
}

//账单记录
export function getBillList(data: {
  current: number,
  size: number,
  start: number,
  end: number
}) {
  return request({
    url: '/billing_record/record',
    method: 'get',
    data
  })
}

//提现
export function withdraw(data: {
  amount: number,
  linkId: string,
  payPassword: string
}) {
  return request({
    url: '/withdrawal/withdrawal',
    method: 'post',
    data
  })
}


//支付
export function pay(data: {
  amount: string,
  goodsId: string,
  goodsTitle: string,
  linkId: string,
  remark: string,
  type: number
}) {
  return request({
    url: '/order/consume_order',
    method: 'post',
    data
  })
}

//重置支付密码
export function resetPayPassword(data: {
  captcha?: string,
  newPassword: string,
  oldPassword?: string,
  phoneAreaPrefix?: string,
  phoneNumber?: string,
  type: number  //0 密码  1 验证码
}) {
  return request({
    url: '/user/modify_pay_password',
    method: 'post',
    data
  })
}

// 上传身份证
export function uploadSfz(data: {
  frontPicCode: string,
  backPicCode: string
}) {
  return request({
    url: '/wallet/supply_card_pic',
    method: 'post',
    data
  })
}
